import React, { useContext } from 'react';
import Inputs from 'components//Inputs';
import useTargetValueModeOptions from '../../../hooks/useTargetValueModeOptions';
import TargetFormContext from '../../../contexts/TargetFormContext';

const ModeDropdown = ({
  target,
  group,
}: {
  target: Targets.Wizard.Target;
  group: Targets.Wizard.TargetGroup;
}) => {
  const { isShowingValidationFeedback, isGridMode } =
    useContext(TargetFormContext);
  const modeOptions = useTargetValueModeOptions({
    target,
    group,
  });

  if (!isGridMode) {
    const isInputInvalid =
      isShowingValidationFeedback &&
      target.categories.length > 0 &&
      target.categories[0].value;
    return (
      <div>
        <Inputs.Dropdown
          testId="target-mode-dropdown"
          options={modeOptions}
          buttonStyle={
            target.categories.length > 0
              ? isInputInvalid
                ? {
                    borderWidth: 1,
                    borderStyle: 'solid',
                    borderBottomRightRadius: 0,
                    borderTopRightRadius: 0,
                    borderLeftColor: 'var(--color-status-error)',
                    borderBottomColor: 'var(--color-status-error)',
                    borderTopColor: 'var(--color-status-error)',
                    borderRightColor: 'var(--color-status-error)',
                    backgroundColor: 'var(--color-status-error-bg)',
                  }
                : {
                    borderBottomRightRadius: 0,
                    borderTopRightRadius: 0,
                    borderRightColor: 'transparent',
                  }
              : undefined
          }
        />
      </div>
    );
  }

  return (
    <div>
      <Inputs.Dropdown testId="target-mode-dropdown" options={modeOptions} />
    </div>
  );
};

export default ModeDropdown;
